import { WorkerSummary } from "../../../Models/Workers/Workers";

export enum WorkersActionsTypes {
  SET_WORKERS_INITIALIZED = "app/workers/set/initialized",
  SET_WORKERS = "app/workers/set/workers",
  SET_NEW_PASSWORD = "app/workers/set/workers/new_password",
}

export interface WorkersActionSetInitialized {
  type: WorkersActionsTypes.SET_WORKERS_INITIALIZED;
  payload: { initialized: boolean };
}

export interface WorkersActionSetWorkers {
  type: WorkersActionsTypes.SET_WORKERS;
  payload: { items: Array<WorkerSummary> };
}

export type WorkersActions = WorkersActionSetInitialized | WorkersActionSetWorkers;
